
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';

interface AdRequestErrorStateProps {
  error: string;
}

const AdRequestErrorState: React.FC<AdRequestErrorStateProps> = ({ error }) => {
  return (
    <Card className="bg-gradient-to-r from-red-50 to-red-50 border-red-200">
      <CardContent className="pt-6 text-center">
        <AlertCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-red-700 mb-2">Erreur de chargement</h3>
        <p className="text-red-600 mb-4">{error}</p>
        <Button 
          onClick={() => window.location.reload()} 
          className="bg-red-500 hover:bg-red-600"
        >
          Réessayer
        </Button>
      </CardContent>
    </Card>
  );
};

export default AdRequestErrorState;
